import React, { PureComponent, createRef } from 'react';
import { cx } from 'emotion';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import selectTable from 'react-table/lib/hoc/selectTable';
import TableHeader from './TableHeader';
import TablePagination from './TablePagination';
import TableSelect from './TableSelect';
import TableSpinner from './TableSpinner';
import TableNoData from './TableNoData';
const CheckboxReactTable = selectTable(ReactTable);
const defaultPageSizes = [10, 20, 50, 100];
const headerHeightAffectingProps = ['condensed', 'filterable'];
export default class ReactTablev6 extends PureComponent {
    constructor() {
        super(...arguments);
        this.tableRef = null;
        this.containerRef = createRef();
        this.state = {
            resolvedData: this.props.data,
            entireHeaderHeight: 0,
        };
        // get the height of the header to use as the offset to the LoadingComponent and NoDataComponent
        this.setMeasurements = () => {
            const [rt] = this.containerRef.current.getElementsByClassName('ReactTable');
            const headers = Array.from(rt.getElementsByClassName('rt-thead'));
            this.setState({ entireHeaderHeight: headers.reduce((agg, h) => agg + h.offsetHeight, 0) });
        };
        this.getVisibleData = () => {
            if (!this.tableRef) {
                return this.props.data || [];
            }
            const resolvedState = this.tableRef.getWrappedInstance().getResolvedState();
            const pageStart = resolvedState.page * resolvedState.pageSize;
            const pageEnd = (resolvedState.page + 1) * resolvedState.pageSize;
            return resolvedState.resolvedData.slice(pageStart, pageEnd);
        };
        this.getPaginationProps = () => {
            const { condensed, perPageLabelText, goToLabelText } = this.props;
            return { condensed, perPageLabelText, goToLabelText };
        };
        this.getTableRef = tableRef => {
            this.tableRef = tableRef;
        };
        this.getTheadThProps = (state, row, column) => {
            const sortable = [column.sortable, state.sortable, false].find(x => x != null);
            const sorted = state.sorted.find(x => x.id === column.id);
            return { sortable, sorted };
        };
        this.getSharedProps = ({ loading, condensed, filterable }) => ({
            loading,
            entireHeaderHeight: this.state.entireHeaderHeight,
            condensed,
            filterable,
        });
    }
    componentDidMount() {
        this.setMeasurements();
    }
    componentDidUpdate(prevProps) {
        if (headerHeightAffectingProps.some(prop => this.props[prop] !== prevProps[prop])) {
            this.setMeasurements();
        }
    }
    render() {
        const { className, condensed, selectable } = this.props;
        const props = Object.assign({ ref: this.getTableRef, className: cx(className, { 'table-condensed': condensed }), 
            // Callbacks for providing custom props to individual components
            getPaginationProps: this.getPaginationProps, getTheadThProps: this.getTheadThProps, getNoDataProps: this.getSharedProps, getLoadingProps: this.getSharedProps, ThComponent: TableHeader, 
            // Defaults for pagination
            defaultPageSize: 10, pageSizeOptions: defaultPageSizes, LoadingComponent: TableSpinner, NoDataComponent: TableNoData, PaginationComponent: TablePagination, 
            // Selection state and callbacks
            selectType: 'checkbox', selectWidth: 73, SelectAllInputComponent: TableSelect, SelectInputComponent: TableSelect, style: { position: 'relative' } }, this.props);
        return (React.createElement("div", { ref: this.containerRef }, selectable ? React.createElement(CheckboxReactTable, Object.assign({}, props))
            : (React.createElement(ReactTable, Object.assign({}, props)))));
    }
}
ReactTablev6.propTypes = {
    className: PropTypes.string,
    condensed: PropTypes.bool,
    selectable: PropTypes.bool,
    data: PropTypes.any,
    keyField: PropTypes.any,
    perPageLabelText: PropTypes.string,
    goToLabelText: PropTypes.string,
};
